import React, { FC, useCallback } from 'react';

import ActionRow from './ActionRow';
import { ActionType, AddTopicsAction as AddTopicsActionType } from 'src/actions/rules/actions';
import { StyledDropdown, StyledTypeDescription } from 'src/presentation/components/pages/rules/shared/StyledComponents';
import useTopics from '../hooks/useTopics';

type AddTopicsActionProps = {
  action: AddTopicsActionType;
  onDelete: Function;
  onUpdate: Function;
};

const AddTopicsAction: FC<AddTopicsActionProps> = ({ action, onDelete, onUpdate }) => {
  const onChangeTopics = useCallback(
    topic => {
      action.updateTopic(topic);
      onUpdate(ActionType.AddTopics, action);
    },
    [action, onUpdate]
  );

  const { dataMergeFinished, topicOptions, disabledTopics } = useTopics();

  if (!dataMergeFinished) return null;
  return (
    <ActionRow type={ActionType.AddTopics} onDelete={onDelete}>
      <StyledTypeDescription>Add Topics</StyledTypeDescription>
      <StyledDropdown
        data-aid="addTopics-selectButton"
        isMultiSelect
        maxRows={5}
        multiSelectLabel="topics"
        onSelect={onChangeTopics}
        options={topicOptions}
        placeholder="Select topics"
        searchable
        value={action.topicIds.filter(id => !disabledTopics.has(id))}
      />
    </ActionRow>
  );
};

export default AddTopicsAction;
